import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { AgGridReact } from "ag-grid-react";
import { createbank, deletebank, listbanks } from "../../../services/admin";
import Swal from "sweetalert2";

export default function BankList() {
    const [show, setShow] = useState(false);
    const [bankList, setBankList] = useState([]);
    const [bankName, setBankName] = useState("");
    const [bankCode, setBankCode] = useState("");
    const [branchName, setBranchName] = useState("");
    const [ifscCode, setIfscCode] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [editId, setEditId] = useState(0);

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 150,
            cellRenderer: function (params) {
                return (
                    <div>
                        <button
                            className="btn btn-sm btn-primary me-2"
                            onClick={() => handleEdit(params.data)}
                        >
                            <i className="fa fa-edit"></i>
                        </button>
                        <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(params.value)}
                        >
                            <i className="fa fa-trash"></i>
                        </button>
                    </div>
                );
            },
        },
        {
            headerName: "Bank Name",
            field: "bank_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
        },
        {
            headerName: "Bank Code",
            field: "bank_code",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
        },
        {
            headerName: "Branch Name",
            field: "branch_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
        },
        {
            headerName: "IFSC Code",
            field: "ifsc_code",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
        },
        {
            headerName: "Account Number",
            field: "account_number",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
        },
    ];

    useEffect(() => {
        funlist();
    }, []);

    function funlist() {
        listbanks().then((res) => {
            if (res.status === true) {
                setBankList(res.data);
            }
        });
    }

    function handleEdit(data) {
        setEditId(data.id);
        setBankName(data.bank_name);
        setBankCode(data.bank_code || "");
        setBranchName(data.branch_name || "");
        setIfscCode(data.ifsc_code || "");
        setAccountNumber(data.account_number || "");
        setShow(true);
    }

    function handleDelete(id) {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                deletebank(id).then((res) => {
                    if (res.status === true) {
                        toast.success(res.message);
                        funlist();
                    } else {
                        toast.error(res.message);
                    }
                });
            }
        });
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!bankName) {
            toast.error("Please enter bank name");
            return;
        }

        const temp = new FormData();
        temp.append("id", editId);
        temp.append("bank_name", bankName);
        temp.append("bank_code", bankCode);
        temp.append("branch_name", branchName);
        temp.append("ifsc_code", ifscCode);
        temp.append("account_number", accountNumber);

        createbank(temp).then((res) => {
            if (res.status === true) {
                toast.success(res.message);
                handleClose();
                funlist();
            } else {
                toast.error(res.message);
            }
        });
    }

    function handleClose() {
        setShow(false);
        setEditId(0);
        setBankName("");
        setBankCode("");
        setBranchName("");
        setIfscCode("");
        setAccountNumber("");
    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Bank Master</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Master</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Bank List
                    </li>
                </ol>
            </div>

            <div className='d-flex justify-content-end'>
                <a className='btn btn-success' onClick={() => setShow(true)}> <i className="fa fa-plus me-2"></i>Add Bank</a>
            </div>

            <div className="row mt-2">
                <div className="col-lg-12">
                    <div className="ag-theme-alpine ag-style" style={{ height: 500 }}>
                        <AgGridReact
                            rowData={bankList}
                            columnDefs={columnDefs}
                            pagination={true}
                            paginationPageSize={10}
                        />
                    </div>
                </div>
            </div>

            {/* Add/Edit Modal */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{editId ? "Edit Bank" : "Add Bank"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">
                                Bank Name <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={bankName}
                                onChange={(e) => setBankName(e.target.value)}
                                placeholder="Enter bank name"
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Bank Code</label>
                            <input
                                type="text"
                                className="form-control"
                                value={bankCode}
                                onChange={(e) => setBankCode(e.target.value)}
                                placeholder="Enter bank code"
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Branch Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={branchName}
                                onChange={(e) => setBranchName(e.target.value)}
                                placeholder="Enter branch name"
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">IFSC Code</label>
                            <input
                                type="text"
                                className="form-control"
                                value={ifscCode}
                                onChange={(e) => setIfscCode(e.target.value.toUpperCase())}
                                placeholder="Enter IFSC code"
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Account Number</label>
                            <input
                                type="text"
                                className="form-control"
                                value={accountNumber}
                                onChange={(e) => setAccountNumber(e.target.value)}
                                placeholder="Enter account number"
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        {editId ? "Update" : "Save"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
